export default "__VITE_ASSET__D7ainiJ8__"